import React from "react";
import type { CellProps } from "react-table";

import { Checkbox } from "../../../../../components/Checkbox/Checkbox";
import type { IData } from "../../../../../types";

interface CheckboxColumnProps {
  cellProps: CellProps<IData>;
  selectedItems: string[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxColumn = ({
  cellProps,
  selectedItems,
  onChange,
}: CheckboxColumnProps) => {
  const { id, state } = cellProps.row?.original || "";
  const isChecked = selectedItems.includes(id);

  return (
    <Checkbox
      value={id}
      checked={isChecked}
      onChange={onChange}
      disabled={state !== "Ready"}
    />
  );
};

export { CheckboxColumn };
